<template>
    <v-card v-if="parts.summary || parts.steps.length" outlined flat class="exam-answer-feedback mt-5 pa-4" role="region" aria-label="ملاحظات على إجابتك">
        <div class="d-flex align-center mb-3 strong-text--text font-weight-bold">
            <v-icon size="20" color="secondary" class="me-2">mdi-comment-text-outline</v-icon>
            <span>ملاحظات على إجابتك</span>
        </div>
        <div v-if="parts.summary" class="medium-text strong-text--text feedback-text" dir="auto">{{parts.summary}}</div>
        <template v-if="parts.steps.length">
            <div class="strong-text--text font-weight-bold mt-4 mb-2">كيف تحصل على الدرجة الكاملة؟</div>
            <ul class="medium-text strong-text--text feedback-steps">
                <li v-for="(step, index) in parts.steps" :key="index" dir="auto">{{step}}</li>
            </ul>
        </template>
    </v-card>
</template>

<script>
import { splitExamFeedback } from '@/helpers/exam-review'
export default {
    props: {feedback: {type: String, default: ''}},
    computed: {parts() {return splitExamFeedback(this.feedback)}},
}
</script>

<style scoped>
.feedback-text, .feedback-steps {white-space: pre-line; overflow-wrap: anywhere; line-height: 1.9;}
.feedback-steps {padding-inline-start: 1.35rem; margin: 0;}
.feedback-steps li + li {margin-top: .5rem;}
</style>
